import React from 'react';
import { Button, Result } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { matchesUrl } from 'findem-helpers';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const StyledResult = styled(Result)`
  background-color: white;
  padding: 48px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Unauthenticated: React.FC = () => {
  const redirectUrl = window.location.pathname + window.location.search;
  const loginUrl = `${matchesUrl}/auth/login${redirectUrl !== '/' ? `?redirect_url=${encodeURIComponent(window.location.href)}` : ''}`;

  return (
    <Container>
      <StyledResult
        status="403"
        title="Please Log In"
        subTitle="Sorry, you must be signed in to access this page."
        extra={
          <Button
            type="primary"
            size="large"
            icon={<LoginOutlined />}
            href={loginUrl}
            rel="noopener noreferrer"
          >
            Log in
          </Button>
        }
      />
    </Container>
  );
};

export default Unauthenticated;
